// extracted by mini-css-extract-plugin
export default {"container":"ColorFilter_container__e8Hph"};